import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./LoginRecoverForm.module.css";
import { EmailIcon } from "../Icons/Icons";

export const LoginRecoverForm = ({ authType, setAuthType, handleRecoverSubmit, email, handleEmail }) => {
  const { t, i18n } = useTranslation();

  if (authType != "RECOVER") return null;
  return (
    <div className={styles.LoginRecoverFormWrapper}>
      <h1 className={styles.text}>{t("login.restore")}</h1>
      <form className={styles.form} onSubmit={handleRecoverSubmit}>
        <div className={styles.inputWrapper}>
          <EmailIcon />
          <input
            className={styles.input}
            type="email"
            onChange={handleEmail}
            value={email}
            placeholder={t("login.yourEmail")}
          />
        </div>
        <span className={styles.help}>
        {t("login.restoreHelpText")}
        </span>
        <button className={styles.submit} type="submit">
        {t("login.send")}
        </button>
      </form>
      <button className={styles.login} onClick={() => setAuthType("PASSWORD")}>
      {t("login.loginToSystem")}
      </button>
    </div>
  );
};
